import { Box, Paper, TextField, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import SimpleTable, { Column } from "./SimpleTable";

interface ActionsProps {
  actionsRows: any[];
  actionsRowsPerPage: number;
  actionsPage: number;
  handleChangeActionsPage: (event: any, newPage: number) => void;
  handleChangeActionsRowsPerPage: (event: any) => void;
  title?: string;
  subtitle?: string;
}

const Actions: React.FC<ActionsProps> = ({
  actionsRows,
  actionsRowsPerPage,
  actionsPage,
  handleChangeActionsPage,
  handleChangeActionsRowsPerPage,
  title,
  subtitle,
}) => {
  const [search, setSearch] = React.useState<string>("");
  // const [status, setStatus] = React.useState<string[]>([]);

  const actionColumns: Column[] = [
    {
      id: "classification",
      label: "Classification",
      width: "25%",
      isSorted: false,
    },
    {
      id: "keyword",
      label: "Keyword",
      width: "20%",
      isSorted: false,
    },
    {
      id: "pageType",
      label: "Page Type",
      width: "30%",
      isSorted: false,
    },
    {
      id: "parentKW",
      label: "Parent Keyword",
      width: "30%",
      isSorted: false,
    },
    {
      id: "searchIntent",
      label: "Search Intent",
      width: "30%",
      isSorted: false,
    },
    {
      id: "searchVolume",
      label: "Search Volume",
      width: "30%",
      isSorted: true,
    },
    {
      id: "relevanceScore",
      label: "Relevance Score",
      width: "30%",
      isSorted: false,
    },
  ];

  // const ITEM_HEIGHT = 80;
  // const ITEM_PADDING_TOP = 8;
  // const MenuProps = {
  //   PaperProps: {
  //     style: {
  //       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
  //       width: 200,
  //     },
  //   },
  // };

  // const categories = ["All"];
  // const statuses = ["All", "ToDo", "Completed", "Review "];

  // const handleCategoryChange = (event: SelectChangeEvent<typeof category>) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setCategory(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };

  // const handleStatusChange = (event: SelectChangeEvent<typeof status>) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setStatus(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };

  const filteredRows = search.trim()
    ? actionsRows.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(search.toLowerCase())
        )
      )
    : actionsRows;

  const [orderBy, setOrderBy] = useState<
    "searchVolume" | "relevanceScore" | ""
  >("searchVolume");
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");

  const handleSort = (columnId: string) => {
    const isAsc = orderBy === columnId && orderDirection === "asc";
    setOrderBy(columnId as "searchVolume" | "relevanceScore");
    setOrderDirection(isAsc ? "desc" : "asc");
  };

  const sortedRows = useMemo(() => {
    if (!orderBy) return filteredRows;
    return [...filteredRows].sort((a, b) => {
      const valA = a[orderBy];
      const valB = b[orderBy];
      if (valA == null) return 1;
      if (valB == null) return -1;
      if (orderDirection === "asc") return valA - valB;
      return valB - valA;
    });
  }, [filteredRows, orderBy, orderDirection]);

  return (
    <Paper
      sx={{ width: "100%", overflow: "hidden", padding: "0 16px 4px 16px" }}
    >
      {(title || subtitle) && (
        <Box sx={{}} paddingY={2}>
          {title && (
            <Typography variant="h5" fontWeight={600}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ letterSpacing: "0.17px" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={3}
        marginTop={2}
      >
        <TextField
          id="search"
          label="Search"
          placeholder="Name, email, etc..."
          size="small"
          value={search}
          onChange={(e: any) => setSearch(e.target.value)}
        />
        {/* <Box display={"flex"} gap={2} width={"400px"}>
          <FormControl fullWidth>
            <InputLabel
              id="category-label"
              sx={{
                '&.MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                  top: -7,
                }
              }}
            >
              Category
            </InputLabel>
            <Select
              labelId="category-label"
              id="category-select"
              multiple
              size="small"
              value={category}
              onChange={handleCategoryChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {categories.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={category.includes(item)} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel
              id="status-label"
              sx={{
                '&.MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                  top: -7,
                }
              }}
            >
              Status
            </InputLabel>
            <Select
              labelId="status-label"
              id="status-select"
              multiple
              size="small"
              value={status}
              onChange={handleStatusChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {statuses.map((item) => (
                <MenuItem key={item} value={item}>
                  <Checkbox checked={status.includes(item)} />
                  <ListItemText primary={item} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box> */}
      </Box>

      <SimpleTable
        columns={actionColumns}
        rows={sortedRows}
        rowsPerPage={actionsRowsPerPage}
        paddingTop="6px"
        paddingBottom="6px"
        page={actionsPage}
        handleChangePage={handleChangeActionsPage}
        handleChangeRowsPerPage={handleChangeActionsRowsPerPage}
        orderBy={orderBy}
        orderDirection={orderDirection}
        onSort={handleSort}
      />
    </Paper>
  );
};

export default Actions;
